import { fabric } from "fabric";
import { ITextboxOptions } from "fabric/fabric-impl";
import { omit } from "lodash";

/**
 * Adds ellipsis charts if word don't fit.
 *
 * Currently works with single-line text.
 *
 * Example:
 * "Description" -> "Descrip..."
 */
export interface IEllipsisTextboxOptions extends ITextboxOptions {
  ellipsis?: boolean;
}

export class EllipsisTextbox extends fabric.Textbox {
  constructor(text: string, options?: IEllipsisTextboxOptions) {
    const textOptions = omit(options, "ellipsis");
    super(text, textOptions);
  }

  _wrapText(lines: string[], desiredWidth: number): string[][] {
    const lineIndex = 0;
    const chartOffset = 0;
    const ellipsis = "...";
    let text = lines[lineIndex];

    let textWidth = this._measureWord([text], lineIndex, chartOffset);
    if (textWidth > desiredWidth) {
      let length = text.length;

      while (textWidth > desiredWidth && !!length) {
        text = text.substring(0, length).trim() + ellipsis;
        textWidth = this._measureWord([text], lineIndex, chartOffset);
        length--;
      }
    }

    return [[text]];
  }
}
